import { useContext, useEffect } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import Link from 'next/link'
import Image from 'next/image'
import { s3Static } from '../../utils/constants'
import { BlogHeaderLinks } from '../../components/blogs/BlogHeaderLinks'
import { contentDate } from '../../utils/article-date-time'
import { BlogsList } from '../../components/blogs/BlogList'
import { blogsMaster } from '../../utils/sg-blogs-data'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../lib/service'
import { getWpHealthFitness, getWpNewHealthFitness, setWpHealthFitness, setWpNewHealthFitness } from '../../service/wp-blogs-store'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-09-22'

export async function getStaticProps() {

    const { modifiedDate, month, year } = contentDate(CONTENT_REVIEWED);
    const fitnessBlogs = blogsMaster['health-fitness'].blogArray;
    const wpPosts = getWpHealthFitness().length > 0 ?  getWpHealthFitness() : await getWpPostsByCategory(6, "health-fitness");
    setWpHealthFitness(wpPosts)
    const wpNewPosts = getWpNewHealthFitness().length > 0 ?  getWpNewHealthFitness() : await getWpNewPostsByCategory(6, "health-fitness");
    setWpNewHealthFitness(wpNewPosts)

  return {
      props: {
        modifiedDate,
        month,
        year,
        fitnessBlogs,
        wpPosts,
        wpNewPosts
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const fitnessBlogs = props.fitnessBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts

  return (
    <>
      <Head>
        <title>Functional Training</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="Functional training primarily involves compound movement exercise to strengthen muscles and joints for our everyday activities."/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/blogs/functional-training" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Functional Training`}/>
        <meta property="og:description" content="Functional training primarily involves compound movement exercise to strengthen muscles and joints for our everyday activities." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-14T07:30:46+00:00" />
        <meta property="article:modified_time" content="2025-01-14T07:30:46+00:00" />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/fitness-girl-lateral-raises.webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/fitness-girl-lateral-raises.webp" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/blogs/functional-training"/>
        <meta name="twitter:title" content={`Functional Training`}/> 
        <meta name="twitter:description" content="Functional training primarily involves compound movement exercise to strengthen muscles and joints for our everyday activities."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/blogs/functional-training" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/blogs/functional-training"},"headline":"Functional Training","description":"Functional training primarily involves compound movement exercise to strengthen muscles and joints for our everyday activities.","image":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/fitness-girl-lateral-raises.webp"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-14T07:30:46+00:00","dateModified":"2022-09-14T07:30:46+00:00"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Blogs","item":"https://www.stringssg.com/blogs"},{"@type":"ListItem","position":1,"name":"functional-fitness"}]}]}`
          }}
        />
      </Head>
      <div className='max-w-5xl mx-auto py-5 px-2'>
            <div className='space-y-2'>
                <h1 className='text-lg text-gray-500 font-semibold'>Functional Training Exercises</h1>
                <div className='text-gray-400 text-xs'>
                    <time dateTime="2022-07-15 00:00">September 14th 2022</time>
                </div>
            </div>
            <div className='py-2 text-gray-500 leading-8 space-y-2'>
                <div className='py-2 space-y-2'>
                    <p className='font-bold'>
                        Functional training primarily involves compound movement exercise to strengthen muscles and joints for our everyday activities.
                    </p>
                    <p className=''>
                    It is very important to understand that, we need to train for life and not for events. 
                    This fitness cum weight loss program is a bridge between personal training and physical therapy.
                    </p>
                </div>
                <div className='relative h-96 max-w-xl'>
                    <Image className='rounded-lg'
                          src={s3Static + "blog/health+and+fitness/Functional-training.webp"}
                          fill
                          style={{objectFit: 'cover'}}
                          placeholder='blur'
                          blurDataURL={s3Static + "placeholder.png"}
                          alt='man doing rope work out'
                    />          
                </div>
                <div className='py-2 space-y-2'>
                    <h2 className='font-bold'>
                        How we benefit from functional training exercises :
                    </h2>
                    <div className='list-decimal space-y-2 p-4'>
                        <p>
                        1. Strengthen muscles – The target of functional training exercises is to strengthen various muscle groups of our body. When our muscles are strong, it improves the overall physical stability and thus helps us to perform daily activities with minimum risks and greater ease.
                        </p>
                        <p>
                        2. Brings in balance and coordination – Functional training include various exercises like single leg balance exercises, lunges, step-ups etc all of which trains our body to balance and coordinate and thereby create a synergy within our body.
                        </p>
                        <p>
                        3. Good posture – We all fall prey to bad postures through our day to day activities. People with desk bound jobs often suffer with spinal issues. Functional fitness exercises are a solution to such bad posture problems.
                        </p>
                        <p>
                        4. Core strength and stability – Functional training exercises like crunches helps to strengthen our core and in turn betters our spine too.
                        </p>
                        <p>
                        5. Power – Functional fitness focus on both upper and lower body. Multiple reps of exercises like push-ups, squats, bur pees helps to develop total body strength and power. This further helps us to move quickly in real life activities.
                        </p>
                        <p>
                        6. Reduces joint pains – Functional training helps the body to get back to basics i.e back to the form it is designed to move and perform. These exercises are very beneficial for chronic joint pains in back, neck or knee.
                        </p>
                    </div>
                    <p>
                        So, the idea is to stay fit year-round. Personal trainers teach these functional exercises which helps to train the muscles and prepare them to perform daily tasks proficiently. So get in touch with the right weight loss trainer or bodybuilding trainer  and get more functionally fit!
                    </p>
                </div>
                <div className='py-2 text-center'>
                    <Link href="/sg/personal-trainer" className='px-3 py-3 border border-amber-600 text-orange-600 rounded-lg'>
                            Find a functional fitness trainer in Singapore
                    </Link>
                </div>
            </div>
            <h2 className='text-center text-xl uppercase pt-10'>You may also like</h2>
            <BlogsList blogs={fitnessBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
      </div>
      <div className='fixed bottom-0 w-full text-center text-lg'>
          <Link href="/sg/personal-trainer" prefetch={false} className='text-white py-3 bg-linear-to-tr from-amber-600 to-amber-400 block font-bold w-full'>
                  Find a functional fitness trainer in Singapore
          </Link>
      </div>
      <BlogHeaderLinks/>
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
